import { render, staticRenderFns } from "./VehicleLayer.vue?vue&type=template&id=60ef5a4b&"
import script from "./VehicleLayer.vue?vue&type=script&lang=js&"
export * from "./VehicleLayer.vue?vue&type=script&lang=js&"
import style0 from "./VehicleLayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports